import script from "./DominanceGuageChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DominanceGuageChart.vue?vue&type=script&setup=true&lang=js"

import "./DominanceGuageChart.vue?vue&type=style&index=0&id=04856ce9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04856ce9"]])

export default __exports__